import { Center, ColorSwatch, Table, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useGetBloodPressureClassification } from 'hooks/api/bloodpressure/useGetBloodPressureClassification';
import { getBloodPressureClassificationColor } from 'utils/measurements/bloodpressure';
import classes from './BloodPressureInfoModal.module.css';

export const BloodPressureInfoModal = () => {
  const { t } = useTranslation();
  const { data: bloodPressureClassification } = useGetBloodPressureClassification();

  const formatValueInRange = (value: number) => (value <= 0 || value >= 999 ? '-' : value);

  const rows = bloodPressureClassification?.data?.classifications.map((classification, index) => (
    <tr key={index}>
      <td>{t(`severity_${classification.label}`)}</td>
      <td>
        <Center>
          <ColorSwatch size={15} color={getBloodPressureClassificationColor(classification.color)} />
        </Center>
      </td>
      <td>
        <Center>{formatValueInRange(classification.systolic.from)}</Center>
      </td>
      <td>
        <Center>{formatValueInRange(classification.systolic.to)}</Center>
      </td>
      <td>
        <Center>{formatValueInRange(classification.diastolic.from)}</Center>
      </td>
      <td>
        <Center>{formatValueInRange(classification.diastolic.to)}</Center>
      </td>
    </tr>
  ));

  return (
    <>
      <Text size={'sm'}>
        {t(`bloodpressure_guidelines_info_title_${bloodPressureClassification?.data.guideLineKey}`)}
      </Text>
      <Table className={classes.bloodPressureInfoModal} my={10}>
        <thead>
          <tr>
            <th>{t('classification_label')}</th>
            <th>
              <Center>{t('color_label')}</Center>
            </th>
            <th colSpan={2}>
              <Center>{t('systolic_label')}</Center>
            </th>
            <th colSpan={2}>
              <Center>{t('diastolic_label')}</Center>
            </th>
          </tr>
        </thead>
        <tbody>{rows}</tbody>
      </Table>
      <Text size={'xs'}>
        {t(`bloodpressure_guidelines_info_source_${bloodPressureClassification?.data.guideLineKey}`)}
      </Text>
    </>
  );
};
